import { AxiosResponse } from 'axios';
import { isPresent } from 'utils/isPresent';

import RestAPI from '../../Common/restApi';

const REQUEST_URL = '/pro/tags';
const AVAILABLE_TAGS_REQUEST_URL = '/pro/available_tags';

export type Tag = {
  id: number;
  name: string;
};

const TagsApi = {
  getTags(): Promise<AxiosResponse<Tag[]>> {
    return RestAPI.get(REQUEST_URL);
  },

  getAvailableTags(type?: string): Promise<AxiosResponse<Tag[]>> {
    if (isPresent(type)) {
      return RestAPI.getWithFormData(AVAILABLE_TAGS_REQUEST_URL, { type });
    }
    return RestAPI.get(AVAILABLE_TAGS_REQUEST_URL);
  },
};

export default TagsApi;
